export const BATTLE_TYPES = {
    RANDOM: 'random',
    TEAM: 'team',
    SKIRMISHES: 'fort_sorties',
    ATTACKS: 'fort_battles',
    GLOBAL_MAP: 'global_map',
    RANKED: 'ranked',
    EPIC: 'epic',
}

export const RANDOM_BATTLE_TYPES = {
    DEFAULT: '15x15',
    EPIC: '30x30',
}



// WEBPACK FOOTER //
// ./utils/clan_management/battles.js